import { useEffect, useState } from 'react'
import Select from 'react-select'
import { arrayPluck, searchArray } from '../../../helpers/arr';
import { transform } from '../../../helpers/transform';

const InputFieldMultiSelect = (props) => {
    const { config, onChange, defaultValue, className, theme } = props;
    const optionTemplate = { value: "", label: "" };
    const [options, setOptions] = useState([]);
    const [valueOption, setValueOption] = useState(config.multi ? [] : optionTemplate);

    const initOptions = async () => {
        let optionsList = transform('options', config.options);
        initValueOptions(optionsList);
        setOptions(optionsList);
    }

    const initValueOptions = (arr) => {
        if (typeof (value) === 'string') {
            const tmp = searchArray(arr, 'value', defaultValue);
            setValueOption(tmp && tmp.value ? tmp : (config.multi ? [] : optionTemplate));
        } else if (Array.isArray(defaultValue)) {
            const values = [];
            defaultValue.forEach(valueItem => {
                const tmp = searchArray(arr, 'value', valueItem);
                if (tmp && tmp.value) {
                    values.push(tmp);
                }
            });
            setValueOption(values ? values : [optionTemplate]);
        } else {
            setValueOption(defaultValue && defaultValue.value ? defaultValue : (config.multi ? [] : optionTemplate));
        }
    }

    const handleChange = (option) => {
        setValueOption(option)
        if (onChange) {
            onChange(arrayPluck(option, 'value'), config.name);
        }
    }

    useEffect(() => {
        initOptions();
    }, [defaultValue]);
    return (
        <>
            <Select
                theme={(t) => ({ ...t, ...theme })}
                name={config && config.name ? config.name : 'select'}
                value={valueOption}
                placeholder={config.placeholder || 'Select...'}
                options={options}
                className={`${className ? className : 'me-2 w-250px'}`}
                closeMenuOnSelect={false}
                isMulti={true}
                onChange={handleChange} />
        </>
    )
}

export default InputFieldMultiSelect